module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('h1', [_c('i', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "start2"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc-red"
  }, [_c('a', {
    attrs: {
      "href": "#/cap00a#page_8"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("  8 INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red"
  }, [_c('a', {
    attrs: {
      "href": "#/cap00b#page_10"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v(" 10 HOW TO USE THIS BOOK")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_13"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v(" 13   APPETIZERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_15"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 15")])]), _vm._v("   Hors D’oeuvres")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_25"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 25")])]), _vm._v("   Dips & Spreads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_30"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 30")])]), _vm._v("   Snacks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap01#page_35"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 35")])]), _vm._v("   Small Dishes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page_51"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v(" 51   SALADS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page_53"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 53")])]), _vm._v("   Composed & Entrée Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page_57"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 57")])]), _vm._v("   Side Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page_66"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 66")])]), _vm._v("   Starter Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/cap02#page_74"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 74")])]), _vm._v("   Dressings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page_79",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v(" 79   SOUPS & STEWS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page_81",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 81")])]), _vm._v("   Hot Soups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page_97",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 97")])]), _vm._v("   Chilled Soups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap03#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v(" 99")])]), _vm._v("   Stews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page_115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("115   SANDWICHES, PIZZAS & BURGERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("117")])]), _vm._v("   Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("128")])]), _vm._v("   Sandwich Salads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page_130",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("130")])]), _vm._v("   Pizzas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap04#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("134")])]), _vm._v("   Hamburgers & Hot Dogs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05#page_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("141   POULTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05#page_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("143")])]), _vm._v("   Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05#page_167",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("167")])]), _vm._v("   Turkey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap05#page_170",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("170")])]), _vm._v("   Duck & Goose")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_175",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("175   MEAT & GAME")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("177")])]), _vm._v("   Beef & Veal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_223",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("223")])]), _vm._v("   Pork")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("235")])]), _vm._v("   Lamb & Goat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_241",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("241")])]), _vm._v("   Offal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap06#page_243",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("243")])]), _vm._v("   Game")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_246",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("246   SEAFOOD")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_249",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("249")])]), _vm._v("   Whole Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_254",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("254")])]), _vm._v("   Fileted Fish")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_265",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("265")])]), _vm._v("   Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_271",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("271")])]), _vm._v("   Scallops")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_273",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("273")])]), _vm._v("   Lobster, Crayfish & Crab")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_282",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("282")])]), _vm._v("   Oysters, Clams & Mussels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap07#page_285",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("285")])]), _vm._v("   Squid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#page_287",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("287   VEGETABLES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("289")])]), _vm._v("   Artichokes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("290")])]), _vm._v("   Asparagus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("292")])]), _vm._v("   Broccoli & Broccoli Rabe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("294")])]), _vm._v("   Brussels Sprouts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("295")])]), _vm._v("   Cabbage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("296")])]), _vm._v("   Carrots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("297")])]), _vm._v("   Cauliflower")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("299")])]), _vm._v("   Corn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("301")])]), _vm._v("   Cucumber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("303")])]), _vm._v("   Eggplant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("304")])]), _vm._v("   Escarole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("304")])]), _vm._v("   Fennel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("305")])]), _vm._v("   Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("307")])]), _vm._v("   Greens")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("308")])]), _vm._v("   Kale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t16",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("309")])]), _vm._v("   Kohlrabi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t17",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("309")])]), _vm._v("   Leeks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t18",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("310")])]), _vm._v("   Mushrooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t19",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("312")])]), _vm._v("   Okra")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t20",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("313")])]), _vm._v("   Onions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t21",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("315")])]), _vm._v("   Peas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t22",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("316")])]), _vm._v("   Peppers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t23",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("317")])]), _vm._v("   Plantains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t24",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("318")])]), _vm._v("   Radishes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t25",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("318")])]), _vm._v("   Scallions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t26",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("319")])]), _vm._v("   Spinach")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t27",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("320")])]), _vm._v("   Squash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t28",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("322")])]), _vm._v("   Sweet Potato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t29",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("323")])]), _vm._v("   Tomato")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t30",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("326")])]), _vm._v("   Turnip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t31",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("326")])]), _vm._v("   Yucca")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap08#t32",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("327")])]), _vm._v("   Zucchini")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_329",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("329   PASTAS, NOODLES & DUMPLINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_331",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("331")])]), _vm._v("   Pastas & Noodles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_346",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("346")])]), _vm._v("   Sauces & Ragù")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_350",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("350")])]), _vm._v("   Baked Pastas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_357",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("357")])]), _vm._v("   Couscous")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap09#page_360",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("360")])]), _vm._v("   Filled Potatoes & Dumplings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10#page_369",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("369   BEANS, GRAINS & POTATOES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10#page_371",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("371")])]), _vm._v("   Beans & Other Legumes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10#page_381",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("381")])]), _vm._v("   Rice & Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap10#page_392",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("392")])]), _vm._v("   Potatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11#page_399",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("399   BREADS & ROLLS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11#page_401",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("401")])]), _vm._v("   Yeast Breads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11#page_436",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("436")])]), _vm._v("   Quick Breads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11#page_439",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("439")])]), _vm._v("   Biscuits, Scones, Rolls & Buns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap11#page_445",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("445")])]), _vm._v("   Flatbreads, Crêpes & Crackers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12#page_453",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("453   BREAKFAST & BRUNCH")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12#page_455",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("455")])]), _vm._v("   Eggs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12#page_465",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("465")])]), _vm._v("   Breakfast Meats")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12#page_468",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("468")])]), _vm._v("   Breakfast Breads")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap12#page_473",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("473")])]), _vm._v("   Doughnuts & Fried Doughs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_477",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("477   DESSERTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_479",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("479")])]), _vm._v("   Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_491",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("491")])]), _vm._v("   Bars, Cookies & Pastries")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_496",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("496")])]), _vm._v("   Candies & Confections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_500",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("500")])]), _vm._v("   Tarts & Pies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_510",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("510")])]), _vm._v("   Fruit Desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_514",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("514")])]), _vm._v("   Ice Creams, Sorbets & Granitas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap13#page_518",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("518")])]), _vm._v("   Mousses, Puddings, Custards & Creams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_525",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("525   DRINKS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_527",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("527")])]), _vm._v("   Cocktails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_541",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("541")])]), _vm._v("   Beer, Wine & Champagne Cocktails")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_544",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("544")])]), _vm._v("   Punches & Pitchers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_546",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("546")])]), _vm._v("   Hot Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap14#page_548",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("548")])]), _vm._v("   Nonalcoholic Drinks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap15#page_553",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("553   THE PANTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap15#page_554",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("554")])]), _vm._v("   Stocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap15#page_559",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("559")])]), _vm._v("   Pickles & Preserves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap15#page_570",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("570")])]), _vm._v("   Spices, Rubs & Blends")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap15#page_574",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("574")])]), _vm._v("   Sauces & Condiments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap16#page_580",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("580   INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap16#page_580a",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("580")])]), _vm._v("    Recipes by Ingredient")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap17#page_607",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("607")])]), _vm._v("   Recipes by Origin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/cap18#page_620",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col2"
  }, [_vm._v("620")])]), _vm._v("   Related Topics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-red1"
  }, [_c('span', {
    attrs: {
      "href": "#/cap20#page_623",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('span', {
    staticClass: "col3"
  }, [_vm._v("623   ACKNOWLEDGMENTS")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74aa95e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0